
<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="话术名称">
                <a-input
                  v-model="queryParam.name"
                  allow-clear
                  placeholder="请输入"
                  @keyup.enter="handleQuery"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择">
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['upkeep:script:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="handleUpdate" v-hasPermi="['upkeep:script:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['upkeep:script:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['upkeep:script:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleCreateFormOk" />
      <create-form ref="innerCreateForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleInnerFormOk" />
      <create-form ref="grandCreateForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleGrandFormOk" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        @expand="onExpand"
      >
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status === 1"
            v-hasPermi="['upkeep:script:edit']"
            @change="handleStatusType(record.id, record.status === 1 ? 0 : 1, 'main', record)"
          />
        </span>
        <span slot="parentId">
          <a-tag color="green">一层</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['upkeep:script:edit']">修改</a>
          <a-divider type="vertical" v-hasPermi="['upkeep:script:edit', 'upkeep:script:remove']" />
          <a-dropdown v-hasPermi="['upkeep:script:edit', 'upkeep:script:remove']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()"><a-icon type="double-right" />更多</a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['upkeep:script:add']">
                <a @click="$refs.innerCreateForm.handleAdd(record)">添加</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['upkeep:script:remove']" v-if="record.status == 0">
                <a @click="handleDelete(record, 'main')">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          rowKey="id"
          :size="tableSize"
          :columns="innerColumns"
          :data-source="innerData[record.id] || []"
          :loading="innerLoading[record.id]"
          :pagination="innerPaginationVisible[record.id] ? innerPagination[record.id] : false"
          :row-selection="{
            selectedRowKeys: innerSelectedRowKeys[record.id] || [],
            onChange: (k, r) => onInnerSelectChange(k, r, record.id),
          }"
          :bordered="tableBordered"
          @expand="onInnerExpand"
        >
          <span slot="status" slot-scope="text, subRow">
            <a-switch
              :checked="subRow.status === 1"
              v-hasPermi="['upkeep:script:edit']"
              @change="handleStatusType(subRow.id, subRow.status === 1 ? 0 : 1, 'inner', subRow)"
            />
          </span>
          <span slot="parentId" slot-scope="text, subRow"><a-tag color="orange">二层</a-tag></span>
          <span slot="operation" slot-scope="text, subRow">
            <a @click="$refs.innerCreateForm.handleUpdate(subRow, undefined)">修改</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()"><a-icon type="double-right" />更多</a>
              <a-menu slot="overlay">
                <a-menu-item><a @click="handleAdd3(subRow)">新增</a></a-menu-item>
                <a-menu-item v-if="subRow.status == 0"><a @click="handleDelete(subRow, 'inner')">删除</a></a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>

          <a-table
            slot="expandedRowRender"
            slot-scope="subRecord"
            rowKey="id"
            :size="tableSize"
            :columns="grandColumns"
            :data-source="grandData[subRecord.id] || []"
            :loading="grandLoading[subRecord.id]"
            :pagination="grandPagination[subRecord.id] || false"
            :row-selection="{
              selectedRowKeys: grandSelectedRowKeys[subRecord.id] || [],
              onChange: (k, r) => onGrandSelectChange(k, r, subRecord.id),
            }"
            :bordered="tableBordered"
            @change="(p) => handleGrandPageChange(p, subRecord)"
          >
            <span slot="status" slot-scope="text, gRow">
              <a-switch
                :checked="gRow.status === 1"
                v-hasPermi="['upkeep:script:edit']"
                @change="handleStatusType(gRow.id, gRow.status === 1 ? 0 : 1, 'grand', gRow)"
              />
            </span>
            <span slot="parentId" slot-scope="text, gRow"><a-tag color="red">三层</a-tag></span>
            <span slot="operation" slot-scope="text, gRow">
              <span :class="getOpCls(gRow)">
                <a @click="$refs.grandCreateForm.handleUpdate(gRow, undefined, 'grand')">修改</a>
                <a-divider type="vertical" />
                <a-dropdown>
                  <a class="ant-dropdown-link">更多<a-icon type="double-right" /></a>
                  <a-menu slot="overlay">
                    <a-menu-item v-if="gRow.status == 0"><a @click="handleDelete(gRow, 'grand')">删除</a></a-menu-item>
                  </a-menu>
                </a-dropdown>
              </span>
            </span>
          </a-table>
        </a-table>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/maintenance/script/index.js'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Script',
  components: { CreateForm },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      statusSubmitting: {},
      updateLevel: 'main',
      updatingRow: null,
      selectedRowKeys: [],
      selectedRows: [],
      innerSelectedRowKeys: {},
      grandSelectedRowKeys: {},
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      errorImage: require('/src/assets/images/defaultImg.png'),
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        status: undefined,
      },
      innerPaginationVisible: {},
      innerData: {},
      innerLoading: {},
      innerPagination: {},
      grandData: {},
      grandLoading: {},
      grandPagination: {},
      currentParentId: null,
      currentGrandParentId: null,
      columns: [
        { title: '话术名称', dataIndex: 'name', align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      innerColumns: [
        { title: '话术名称', dataIndex: 'name', align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      grandColumns: [
        { title: '话术名称', dataIndex: 'name', align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleAdd3(subRow) {
      this.$refs.grandCreateForm.handleAdd(subRow, 3)
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10, name: undefined, status: undefined }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onInnerSelectChange(keys, rows, pid) {
      this.$set(this.innerSelectedRowKeys, pid, keys)
    },
    onGrandSelectChange(keys, rows, pid) {
      this.$set(this.grandSelectedRowKeys, pid, keys)
    },
    async handleStatusType(id, newStatus, level = 'main', row = null) {
      if (this.statusSubmitting[id]) return
      this.$set(this.statusSubmitting, id, true)
      this.updateLevel = level
      this.updatingRow = row
      const oldStatus = row ? row.status : level === 'main' ? this.list.find((i) => i.id === id)?.status : undefined
      if (row) row.status = newStatus
      try {
        await statusObj({ id, status: newStatus })
        this.$message.success('状态更新成功')
        this.reloadCurrentTable()
      } catch (e) {
        if (row) row.status = oldStatus
        this.$message.error(e.msg || '状态更新失败')
      } finally {
        this.$set(this.statusSubmitting, id, false)
      }
    },
    reloadCurrentTable() {
      switch (this.updateLevel) {
        case 'main':
          this.getList()
          break
        case 'inner':
          this.loadInner(
            { id: this.currentParentId },
            this.innerPagination[this.currentParentId]?.current || 1,
            this.innerPagination[this.currentParentId]?.pageSize || 5
          )
          break
        case 'grand':
          this.loadGrand(
            { id: this.currentGrandParentId },
            this.grandPagination[this.currentGrandParentId]?.current || 1,
            this.grandPagination[this.currentGrandParentId]?.pageSize || 5
          )
          break
      }
    },
    handleAdd() {
      this.$refs.createForm.handleAdd()
    },
    handleUpdate() {
      const id = this.selectedRowKeys[0]
      this.$refs.createForm.handleUpdate({ id })
    },
    handleDelete(row, level = 'main') {
      const ids = row.id ? [row.id] : this.selectedRowKeys
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk: () =>
          delObj(ids.map((id) => ({ id }))).then(() => {
            this.$message.success('删除成功', 3)
            if (level === 'main') {
              this.onSelectChange([], [])
              this.getList()
            } else if (level === 'inner') {
              this.loadInner(
                { id: this.currentParentId },
                this.innerPagination[this.currentParentId]?.current || 1,
                this.innerPagination[this.currentParentId]?.pageSize || 5
              )
            } else if (level === 'grand') {
              this.loadGrand(
                { id: this.currentGrandParentId },
                this.grandPagination[this.currentGrandParentId]?.current || 1,
                this.grandPagination[this.currentGrandParentId]?.pageSize || 5
              )
            }
          }),
      })
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'upkeep/script/export',
            { ...that.queryParam },
            `script_${new Date().getTime()}.xlsx`
          )
        },
      })
    },
    handleCreateFormOk() {
      this.getList()
    },
    handleInnerFormOk() {
      if (!this.currentParentId || !this.innerPagination[this.currentParentId]) {
        this.getList()
        return
      }
      this.loadInner(
        { id: this.currentParentId },
        this.innerPagination[this.currentParentId].current,
        this.innerPagination[this.currentParentId].pageSize
      )
    },
    handleGrandFormOk() {
      if (!this.currentGrandParentId || !this.grandPagination[this.currentGrandParentId]) {
        this.getList()
        return
      }
      this.loadGrand(
        { id: this.currentGrandParentId },
        this.grandPagination[this.currentGrandParentId].current,
        this.grandPagination[this.currentGrandParentId].pageSize
      )
    },
    onExpand(expanded, record) {
      if (!expanded) return
      this.currentParentId = record.id
      this.$set(this.innerPagination, record.id, {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      })
      this.$set(this.innerPaginationVisible, record.id, true)
      this.loadInner(record)
    },
    loadInner(record, page = 1, size = 5) {
      this.$set(this.innerLoading, record.id, true)
      fetchList({ pageNum: page, pageSize: size, parentId: record.id }).then((res) => {
        this.$set(this.innerData, record.id, res.data.records)
        const pager = this.innerPagination[record.id]
        pager.total = res.data.total
        pager.current = page
        pager.pageSize = size
        this.$set(this.innerLoading, record.id, false)
      })
    },
    handleInnerPageChange(pagination, record) {
      this.loadInner(record, pagination.current, pagination.pageSize)
    },
    onInnerExpand(expanded, record) {
      if (!expanded) {
        this.$set(this.innerPaginationVisible, this.currentParentId, true)
        return
      }
      this.currentGrandParentId = record.id
      this.$set(this.innerPaginationVisible, this.currentParentId, false)
      this.$set(this.grandPagination, record.id, {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      })
      this.loadGrand(record)
    },
    loadGrand(record, page = 1, size = 5) {
      this.$set(this.grandLoading, record.id, true)
      fetchList({ pageNum: page, pageSize: size, parentId: record.id }).then((res) => {
        this.$set(this.grandData, record.id, res.data.records)
        const pager = this.grandPagination[record.id]
        pager.total = res.data.total
        pager.current = page
        pager.pageSize = size
        this.$set(this.grandLoading, record.id, false)
      })
    },
    handleGrandPageChange(pagination, record) {
      this.loadGrand(record, pagination.current, pagination.pageSize)
    },
    getOpCls(record) {
      return this.selectedRowKeys.includes(record.id) ? 'op-highlight' : ''
    },
  },
}
</script>

<style scoped>
.ant-table-thead > tr > th {
  background-color: #303133;
  color: #fff;
  font-weight: 600;
}
.ant-table-tbody > tr:nth-child(even) {
  background-color: #fafafa;
}
.ant-table-tbody > tr:nth-child(odd) {
  background-color: #ffffff;
}
.op-highlight {
  color: #1890ff;
  font-weight: bold;
}
</style>
